'use es6';

import appleLogo from 'bender-url!../../img/apple-logo.png';
import chatSpotLogo from '!bender-url!../../img/chatspot-icon.png';
import connectLogo from '!bender-url!../../img/connect.com-full-logo-color.svg';
import desktopCircle from 'bender-url!../../img/circle_desktop.svg';
import desktopDonut from 'bender-url!../../img/donut_desktop.svg';
import googleLogo from 'bender-url!../../img/google-logo.png';
import hubspotLogo from 'bender-url!../../img/HubSpot.svg';
import hubspotLogoMobile from 'bender-url!../../img/HubSpot-sprocket-color.png';
import hubspotMobileApp2FA from 'bender-url!../../img/hubspotMobileApp2FA.png';
import loginMarketingImage from 'bender-url!../../img/SUI_desktop.svg';
import microsoftLogo from 'bender-url!../../img/ms-logo.png';
import mobileDonut from 'bender-url!../../img/donut_mobile.svg';
import openAiLogo from 'bender-url!../../img/openai-logo-black.svg';
import openAiLogoWhite from 'bender-url!../../img/openai-logo-white.svg';
import oktaLogo from 'bender-url!../../img/okta-logo.svg';
import oneLoginLogo from 'bender-url!../../img/onelogin-logo.svg';
import passkeyLogo from 'bender-url!../../img/passkey-logo.svg';
import unsupportedBrowser from 'bender-url!../../img/unsupported-browser.svg';
export default {
  appleLogo,
  chatSpotLogo,
  connectLogo,
  desktopCircle,
  desktopDonut,
  googleLogo,
  hubspotLogo,
  hubspotLogoMobile,
  hubspotMobileApp2FA,
  loginMarketingImage,
  microsoftLogo,
  mobileDonut,
  oktaLogo,
  openAiLogo,
  openAiLogoWhite,
  oneLoginLogo,
  passkeyLogo,
  unsupportedBrowser
};